import React from 'react';
import { format, parseISO } from 'date-fns';
import { Flex, TextV2, IconV2, ButtonV2, Box } from '@withjoy/joykit';
import { People } from '@withjoy/joykit/icons';
import { useRecentUpdatesController } from './RecentUpdates.controller';
import { Item } from './components/Item/Item';
import { Contact } from '@apps/contactCollector/ContactCollector.controller';

interface RecentUpdatesProps
  extends Readonly<{
    contacts?: Maybe<Contact>[];
    eventHandle: string;
  }> {}

export const RecentUpdates: React.FC<RecentUpdatesProps> = ({ contacts, eventHandle }) => {
  const { handleOnGoToGuestList, tq } = useRecentUpdatesController(eventHandle);

  const renderContactsList = () =>
    !contacts?.length ? (
      <Item
        title={tq`Start sharing!`}
        subTitle={tq`Your updated contacts will appear here.`}
      />
    ) : (
      <Box>
        {contacts.map(contact => (
          <Item
            key={`${contact?.firstName}-${contact?.lastName}-${contact?.createdAt}`}
            title={contact?.firstName && contact?.lastName ? `${contact.firstName} ${contact.lastName}` : tq`Contact Name`}
            subTitle={contact?.createdAt ? format(parseISO(contact.createdAt), 'PPPPpp') : tq`Creation Date`}
          />
        ))}
      </Box>
    );

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      width={['100%', null, '375px']}
      marginTop="48px"
      marginBottom={['42px', null, 0]}
      paddingBottom={[0, null, '20px']}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
      >
        <TextV2
          typographyVariant="hed4"
          fontWeight={700}
          color="mono14"
        >
          {tq`Recent Updates`}
        </TextV2>
        <ButtonV2
          variant="ghost"
          intent="neutral"
          shape="rounded"
          onClick={handleOnGoToGuestList}
          paddingX={0}
        >
          <IconV2
            size="md"
            marginRight="8px"
          >
            <People />
          </IconV2>{' '}
          {tq`Edit Guest List`}
        </ButtonV2>
      </Flex>
      {renderContactsList()}
    </Flex>
  );
};
